import { render, staticRenderFns } from "./createQuiz.vue?vue&type=template&id=750621af&scoped=true&"
import script from "./createQuiz.vue?vue&type=script&lang=js&"
export * from "./createQuiz.vue?vue&type=script&lang=js&"
import style0 from "./createQuiz.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./createQuiz.vue?vue&type=style&index=1&id=750621af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750621af",
  null
  
)

export default component.exports